import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';
import GoogleAnalytics from './components/GoogleAnalytics';

// Public Pages
import Home from './pages/Home';
import QuemSomos from './pages/QuemSomos';
import ProdutosServicos from './pages/ProdutosServicos';
import TrabalheConosco from './pages/TrabalheConosco';
import Parceiros from './pages/Parceiros';
import MatrizFiliais from './pages/MatrizFiliais';
import CultivarLog from './pages/CultivarLog';
import CultivarCafe from './pages/CultivarCafe';
import Contato from './pages/Contato';
import Produtos from './pages/Produtos';
import ProdutoDetalhes from './pages/ProdutoDetalhes';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProdutos from './pages/admin/AdminProdutos';
import AdminProdutoForm from './pages/admin/AdminProdutoForm';
import AdminContatos from './pages/admin/AdminContatos';
import AdminCurriculos from './pages/admin/AdminCurriculos';

function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics />
      <Routes>
        {/* Admin Routes (without Header/Footer) */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/produtos" element={<AdminProdutos />} />
        <Route path="/admin/produtos/novo" element={<AdminProdutoForm />} />
        <Route path="/admin/produtos/:id/editar" element={<AdminProdutoForm />} />
        <Route path="/admin/contatos" element={<AdminContatos />} />
        <Route path="/admin/curriculos" element={<AdminCurriculos />} />

        {/* Public Routes (with Header/Footer) */}
        <Route
          path="/*"
          element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/quem-somos" element={<QuemSomos />} />
                <Route path="/produtos-servicos" element={<ProdutosServicos />} />
                <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
                <Route path="/parceiros" element={<Parceiros />} />
                <Route path="/localizacao" element={<MatrizFiliais />} />
                <Route path="/cultivar-log" element={<CultivarLog />} />
                <Route path="/cultivar-cafe" element={<CultivarCafe />} />
                <Route path="/contato" element={<Contato />} />
                <Route path="/produtos" element={<Produtos />} />
                <Route path="/produtos/:slug" element={<ProdutoDetalhes />} />
              </Routes>
              <Footer />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;